import React, { useId } from 'react';
import SvgRobot from '@icons/ai-robot.svg?react';
import SvgAiMagic from '@icons/ai-magic.svg?react';
import CustomTooltip from '@components/ringil3/Tooltip/CustomTooltip.tsx';

export type AiAlertButtonProps = {
  title: React.ReactNode;
  subIcon?: React.ReactNode;
  tooltip?: string;
  className?: string;
};

export const AiAlertButton: React.FC<AiAlertButtonProps> = ({
                                                              title,
                                                              subIcon,
                                                              tooltip,
                                                              className,
                                                            }) => {
  const safeId = `airobot_${useId().replace(/:/g, '-')}`;

  return (
    <div className="flex flex-col items-start">
      <div
        id={safeId}
        className={`w-fit flex h-[29px] px-2 justify-center items-center gap-2 rounded-lg border border-solid relative cursor-auto ${className ?? ''}`}
      >
        <span className="relative flex items-center">
          <SvgRobot width={24} height={24} />
          <div
            className={`absolute -right-0.5 -bottom-0.5`}
          >
            {subIcon}
          </div>
        </span>
        <span>{title}</span>
        <SvgAiMagic className="w-5 h-5 text-content-brand" />
      </div>
      {tooltip && (
        <CustomTooltip targetSelector={`#${safeId}`} content={tooltip} />
      )}
    </div>
  );
};